import { createSelector } from "reselect"
import { initialState } from "./reducer"




/**
 * Direct selector to the divisionEdit state domain
 */

const selectDivisionEditDomain = (state) =>
  state.get("divisionEdit", initialState)

/**
 * Other specific selectors
 */

export const makeSelectLanguage = () =>
  createSelector(selectDivisionEditDomain, (state) => state.get("languages"))

export const makeSelectIsLoadingLanguage = () =>
  createSelector(selectDivisionEditDomain, (state) =>
    state.get("isLoadingLanguage")
  )
//  GET DIVISION
export const makeSelectIsLoadingDivision = () =>
  createSelector(selectDivisionEditDomain, (state) =>
    state.get("isLoadingDivision")
  )

export const makeSelectDivision = () =>
  createSelector(selectDivisionEditDomain, (state) => state.get("division"))

// GET HISTORY
export const makeSelectIsLoadingHistory = () =>
  createSelector(selectDivisionEditDomain, (state) =>
    state.get("isLoadingHistory")
  )

export const makeSelectHistory = () =>
  createSelector(selectDivisionEditDomain, (state) => state.get("history"))

// GET CHILDREN DIVISION
export const makeSelectIsLoadingChildrenDivision = () =>
  createSelector(selectDivisionEditDomain, (state) =>
    state.get("isLoadingChildrenDivision")
  )

export const makeSelectChildrenDivision = () =>
  createSelector(selectDivisionEditDomain, (state) =>
    state.get("childrenDivision")
  )

// GET DIVISION PARENTS
export const makeSelectIsLoadingDivisionParents = () =>
  createSelector(selectDivisionEditDomain, (state) =>
    state.get("isLoadingDivisionParents")
  )

export const makeSelectDivisionParents = () =>
  createSelector(selectDivisionEditDomain, (state) =>
    state.get("divisionParents")
  )

// GET SUBDIVISIONS WITHOUT PARENT
export const makeSelectIsLoadingSubdivisionsWithoutParents = () =>
  createSelector(selectDivisionEditDomain, (state) =>
    state.get("isLoadingSubdivisionsWihoutParent")
  )

export const makeSelectSubivisionsWithoutParents = () =>
  createSelector(selectDivisionEditDomain, (state) =>
    state.get("subdivisionsWithoutParent")
  )

// GET COLLABORATORS DIVISION
export const makeSelectIsLoadingCollaboratorsDivision = () =>
  createSelector(selectDivisionEditDomain, (state) =>
    state.get("isLoadingCollaboratorsDivision")
  )

export const makeSelectCollaboratorsDivision = () =>
  createSelector(selectDivisionEditDomain, (state) =>
    state.get("collaboratorsDivision")
  )

// MESSAGE ERROR CHANGE NAME
export const makeSelectMessageErrorUpdateName = () =>
  createSelector(selectDivisionEditDomain, (state) =>
    state.get("messageErrorUpdateName")
  )

// MESSAGE DELETE SUBDIVISION
export const makeSelectMessageDeleteSubdivision = () =>
  createSelector(selectDivisionEditDomain, (state) =>
    state.get("messageDeleteSubdivision")
  )

export const makeSelectListEmployees = () =>
  createSelector(selectDivisionEditDomain, (state) =>
    state.get("listEmployees")
  )

export const makeSelectListDivisions = () =>
  createSelector(selectDivisionEditDomain, (state) =>
    state.get("listDivisions")
  )

/**
 * Default selector used by DivisionEdit
 */

const makeSelectDivisionEdit = () =>
  createSelector(selectDivisionEditDomain, (substate) => substate.toJS())

export default makeSelectDivisionEdit
export { selectDivisionEditDomain }
